<template>
<!-- 视力报告 -->
    <div class="VisionReport">
        <div class="content">
            <!-- <img src="../assets/icon @2x.png">
            <p>此功能正在紧张开发中</p>
            <p>敬请期待...</p> -->

            <p class="title">加加明物联网远程管理系统</p>
            <img class="home" src="../assets/icon-fangzi@2x.png">
            <div class="input_box">
                <input type="text" v-model="cname" placeholder="请输入查询码">
                <span class="go_in" @click="go_in">
                    进入
                </span>
            </div>

            
        </div>


        <!-- 底部 -->
        <footer class="footer">
            <ul>
                <li>
                    <router-link :to="{name: 'Home'}">
                        <img src="../assets/icon_shouye@2x.png" alt="首页图标">
                        <p>首页</p>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'VisionReport'}">
                        <img src="../assets/icon_shilibaogao@2x.png" alt="视力报告">
                        <p>视力报告</p>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'ShoppingMall'}">
                        <img src="../assets/icon@2x.png" alt="商城图标">
                        <p>商城</p>
                    </router-link>
                </li>
            </ul>
        </footer>
    </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
export default {
    props: {

    },
    data() {
        return {
            cname: '',
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {
        go_in() {
            if(this.cname == '') {
                Toast('请填写查询码');
                return false 
            }
            this.$router.push({
                name: 'SchoolPage',
                params: {
                    cname: this.cname
                }
            })
        }
    },
    components: {

    },
};
</script>

<style scoped>
.VisionReport {
    height: 100%;
}
.content {
    text-align: center;
    background: #f8f8f8;
    height: 100%;
}

.content .title {
    font-size: 40px;
    padding: 130px 0 0;
}
.content .home {
    width: 400px;
    margin: 100px 0;
}

.content .input_box {
    width: 100%;
    height: 160px;
    line-height: 160px;
    background: #fff;
    margin: 0 auto;
    border-radius: 20px;
}

.content .input_box input {
    height: 68px;
    line-height: 68px;
    font-size: 34px;
    color: #999999;
    text-align: center;
    border: 0px;
    border-bottom: 2px solid #f0f0f0;
}

.content .go_in {
    display: inline-block;
    width: 120px;
    text-align: center;
    height: 70px;
    font-size: 40px;
    line-height: 70px;
    color: #fff;
    background: #3f8ed4;
    border-radius: 20px;
}
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/VisionReport.vue